import { History, LocationState } from 'history';
import { startsWith } from 'lodash/fp';
import history from '../../../routing/history';
import { interpolateUrl } from '../Url';

const withoutAppPrefix = (t: string): string => t.replace(/^\/app\//, '/');
const isSamePage = (a: string, b: string): boolean => withoutAppPrefix(a) === withoutAppPrefix(b);

function isSinglePageApp(h?: History): h is History {
    return !!h;
}

export function redirect(url: string, params: { [key: string]: string } = {}, forceReload: boolean = true) {
    if (typeof window === 'undefined') {
        return;
    }

    window.onbeforeunload = null;

    const realUrl = interpolateUrl(url, params);

    if (!forceReload && history && isSamePage(history.location.pathname, realUrl)) {
        return;
    }
    goToUrl(realUrl);
}

const warnAboutStateNotSupported = (state: LocationState) =>
    state && console.error('Passing state is not supported when navigating outside the SPA.'); // eslint-disable-line no-console

export function goToUrl(url: string, state?: LocationState) {
    if (isSinglePageApp(history) && isSinglePageAppPath(url)) {
        history.push(withoutAppPrefix(url), state);
    } else {
        warnAboutStateNotSupported(state);
        window.location.href = url;
    }
}

export function replaceUrl(url: string, state?: LocationState): void {
    if (isSinglePageApp(history) && isSinglePageAppPath(url)) {
        history.replace(withoutAppPrefix(url), state);
    } else {
        warnAboutStateNotSupported(state);
        window.location.replace(url);
    }
}

export function openInNewTab(url: string): void {
    window.open(url, '_blank');
}

export function isSinglePageAppPath(path: string): boolean {
    return startsWith('/app/', path);
}
